import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { PortfolioProvider } from "@/context/PortfolioContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import Admin from "@/pages/Admin";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <ThemeProvider>
      <PortfolioProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />}>
                  <Route index element={<Home />} />
                </Route>

                <Route path="/auth" element={<Auth />}>
                  <Route index element={<Auth />} />
                </Route>

                <Route path="/admin" element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                } />
              </Routes>
            </BrowserRouter>
          </div>
        </AuthProvider>
      </PortfolioProvider>
    </ThemeProvider>
  );
}

export default App;
